import React, { useEffect } from 'react'
import {useSelector, useDispatch} from 'react-redux'
import { Table } from 'react-bootstrap'
import TableCharacter from '../components/TableCharacter.js'
import loadingImage from '../assets/loading.gif'
import {getCharacters} from '../store/action/characterActions.js'

const HarryPotter = () => {
    const dispatch = useDispatch()
    const opening = "Welcome to Harry Potter's Web!"
    const harryPottersCharacters = useSelector((state) => state.characterReducer.harryPottersCharacters);
    useEffect(() => {
        dispatch(getCharacters())
    }, [dispatch])

    if(!harryPottersCharacters) {
        return <img id="displayedImage" src={loadingImage} alt=""/>
    }

    return (
        <>
            <div >
                <h1 className="opening" style={{marginTop:"5px", marginBottom:"10px"}}>{opening}</h1>
                <div className="container" id="tableCharacter" >
                    <Table striped bordered >
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col"><h5>Character Name</h5></th>
                            <th scope="col"><h5>House</h5></th>
                            <th scope="col"><h5>Role</h5></th>
                            <th scope="col"><h5>School</h5></th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody >
                        { harryPottersCharacters && harryPottersCharacters.map((character, index) => (
                            <TableCharacter key={index} mappingCharacter={character} index={index} />
                        )) }
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}

export default HarryPotter